interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
}: SectionHeadingProps) {
  const alignment = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col gap-3 md:gap-4 ${alignment}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs md:text-sm font-medium text-accent-800">
          <i className="ri-sparkling-2-fill text-accent-500 w-3 h-3 flex items-center justify-center"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {description && (
        <p className="max-w-2xl text-sm md:text-base text-foreground-600 leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}